import { Action } from '@ngrx/store';

export class TraderTrialInfoAction implements Action {
  public static traderTrialInfo: string = '[Report] trader_trial_info';
  public static traderTrialInfoError: string =
    '[Report] trader_trial_info_error';
  public static traderTrialInfoSuccess: string =
    '[Report] trader_trial_info_success';
  public static activateTrialTrader: string = '[User] activate_trial_trader';
  public static activateTrialTraderError: string =
    '[User] activate_trial_trader_error';
  public static activateTrialTraderSuccess: string =
    '[User] activate_trial_trader_success';

  constructor(public type: string, public payload?: any) {}
}
